import { Link } from 'react-router-dom';
import type { EventItem } from '@/mocks/events';
import { formatDate, formatViews } from '@/utils/news';

interface RelatedListProps {
  items: EventItem[];
}

export default function RelatedList({ items }: RelatedListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <h3 className="font-heading font-bold text-base text-foreground-950 mb-3 flex items-center gap-2">
        <i className="ri-thumb-up-line text-primary-600"></i>
        相关推荐
      </h3>
      <ul className="space-y-3">
        {items.map((item) => (
          <li key={item.id}>
            <Link to={`/detail/${item.id}`} className="group flex gap-3">
              <div className="w-20 h-16 shrink-0 rounded-md overflow-hidden bg-secondary-100">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面`}
                  title={`${item.title} - 网红大赛`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h4 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h4>
                <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-0.5">
                    <i className="ri-calendar-line"></i>
                    {formatDate(item.date)}
                  </span>
                  <span className="inline-flex items-center gap-0.5">
                    <i className="ri-eye-line"></i>
                    {formatViews(item.views)}
                  </span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}